export default __webpack_public_path__ + "static/media/Drbeckmann-icon.4e3c9733.png";